var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creator_detail_wrap"},[_c('utility-detail-component',{attrs:{"utilityType":'utilityDetail',"utilityKey":_vm.utilityKey}}),_c('utility-detail-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }